import React from 'react';
import { Box, Chip, withStyles } from '@material-ui/core';

const styles = {
  customChip: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '&:hover': {
      cursor: 'pointer',
    },
    borderRadius: '0 3px 3px 0',
    height: 24,
  },
};

export const isColorLight = (color) => {
  const rgb = hexToRgb(color);
  const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
  return luminance > 0.5;
};

const hexToRgb = (hex) => {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return { r, g, b };
};

function ChipTag({ etiqueta_id, nombre, color, classes, onDelete, size }) {
  const textColor = isColorLight(color) ? '#000000' : '#ffffff';
  return (
    <Box display="flex" alignItems="center" position='relative'>
      <span
        style={{
          borderColor: `transparent ${color} transparent transparent`,
          borderStyle: 'solid',
          height: 24,
          borderWidth: '8px 7px 8px 0',
        }}
      />
      <span style={{
        position: 'absolute',
        width: '5px',
        height: '5px',
        backgroundColor: 'white',
        borderRadius: '50%',
        left: '6px',
      }} />
      <Chip
        label={nombre}
        style={{
          backgroundColor: color,
          color: textColor,
        }}
        size={size || 'small'}
        className={classes.customChip}
        onDelete={onDelete ? () => onDelete(etiqueta_id) : false}
      />
    </Box>
  );
}

export default withStyles(styles)(ChipTag);
